import React, {Component} from 'react'

import IpadNavigation from 'Navigation/IpadNavigation'
import Smartphones from 'Reports/views/FinancialReport/FinancialReportsView/containers/Smartphones'

export default class FinancialReportsView extends Component {
  render () {
    return (
      <IpadNavigation {...this.props} onlyLeftSide>
        <Smartphones {...this.props} />
      </IpadNavigation>
    )
  }
}
